<template>
  <div>
    <div id="concentration" v-if="isShelves">
      <Left :detailsData="detailsData"></Left>
      <Center :detailsData="detailsData"></Center>
      <Right
        :wenxian="wenxian"
        :detailsData="detailsData"
        :autherInfo="autherInfo"
        :periodiID="periodiID"
        :periodicalInfo="periodicalInfo"
      />
    </div>
    <div id="concentration" v-else>
      <Shelves />
    </div>
  </div>
</template>

<script>
// import { nextTick } from "vue/types/umd";
import Shelves from "../components/shelves";
import Left from "../components/left";
import Center from "./components/center";
import Right from "./components/Right";
import {changeTitle, changeDescription} from "@/utils/brower.js";
export default {
  name: "index",
  components: { Left, Center, Right, Shelves },
  data() {
    return {
      detailsData: {},
      wenxian: [],
      autherInfo: {},
      // autherList: {},
      periodiID: {},
      periodicalInfo: {},
      isShelves: true
    };
  },
  created() {
    this.getDetails();
  },
  methods: {
    async getperiodiID() {
      let obj = {
        periodicalId: this.detailsData.data.companyId,
      };
      const res = await this.$apis.recomendServe.periodiID(obj);
      this.periodiID = res.data;
    },
    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        title: encodeURI(this.detailsData.data.monographName),
        pageNo: 1,
        pageSize: 5,
        // title: "专著",
      });
      try {
        this.wenxian = data.list;
      } catch (e) {
        console.log(e);
      }
    },
    async Getperiodical() {
      let obj = {
        type: this.detailsData.data.userType,
        // userId: this.detailsData.data.createUser,
        companyId: this.detailsData.data.companyId,
      };
      const res = await this.$apis.recomendServe.getAuthor(obj);
      this.periodicalInfo = res.content;
    },
    async getDetails() {
      let res = await this.$apis.recomendServe.getDetails({
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
      });
      if (res.resultCode === "200") {
        this.detailsData = res.data;
        changeTitle(this.$global.matchReg(this.detailsData.data.monographName))
        changeDescription(this.$global.matchReg(this.detailsData.data.artSummary))
        await this.getwenxian();
        if (this.detailsData.data.userType === 1) {
          await this.Getperiodical();
          await this.getperiodiID();
        } else {
          await this.getAuthor();
        }
      } else if (res.resultCode === "10401002" || res.resultCode === "10401001") {
        this.isShelves = false
      }
    },
    async getAuthor() {
      let userobj = {
        type: this.detailsData.data.userType,
      };
      if (this.detailsData.data.userType == 0) {
        userobj["userId"] = this.detailsData.data.createUser;
      } else {
        userobj["companyId"] = this.detailsData.data.companyId;
      }
      const res = await this.$apis.recomendServe.getAuthor(userobj);
      this.autherInfo = res.content;
    },
  },
};
</script>

<style lang="scss" scoped>
#concentration {
  width: 1300px;
  display: flex;
}
</style>
